import { Injectable } from '@angular/core';
import { DataSource, SelectionModel } from '@angular/cdk/collections';
import { Store } from '@ngrx/store';
import { IState } from '../models/state';
import { PageEvent, Sort } from '@angular/material';
import { Observable } from 'rxjs/Observable';
import { deleteNullFromJson } from './delete-nulls-from-json';

@Injectable()
export class DataSourceUtils<T> extends DataSource<T> {
  protected data;
  protected params: any = {};
  protected pageIndex: number;
  public total: number;
  public selection = new SelectionModel<T>(true, []);

  constructor(protected store: Store<IState>) {
    super();
  }

  public empty: boolean;

  connect(): Observable<T[]> {
    return this.onConnect()
      .do(([data, total]) => {
        this.data = data;
        this.total = total;
      })
      .map(([data, total]) => data)
      .do(data => (this.empty = !!data.length))
      .do(() => {
        this.selection.clear();
      });
  }

  update() {}

  onConnect() {
    return Observable.of([[], 0]) as any;
  }

  disconnect() {}

  search(params) {
    this.addParams({
      ...params,
      ...{
        page: 1
      }
    });
    this.pageIndex = 0;
    this.update();
  }

  page(event: PageEvent) {
    this.addParams({
      limit: event.pageSize,
      page: event.pageIndex + 1
    });
    this.update();
  }

  sort(event: Sort) {
    this.addParams({
      orderColumn: event.active,
      direction: event.direction.toUpperCase()
    });
    this.update();
  }

  addParams(params) {
    this.params = Object.assign(this.params, params);
    this.params = deleteNullFromJson(this.params);
  }

  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.data.length;
    return numSelected === numRows;
  }

  masterToggle() {
    this.isAllSelected() ? this.selection.clear() : this.data.forEach(row => this.selection.select(row));
  }
}
